// extracted by mini-css-extract-plugin
module.exports = {"dark":"styles_dark__ExT5G"};